import {useLocation, useNavigate} from 'react-router-dom';
import { useState } from 'react';
import { useAppContext } from '../context/AppContext';
import Swal from "sweetalert2";
import { useTranslation } from 'react-i18next';


function Feedback(){
    const navigate = useNavigate();
            const { t } = useTranslation();
    
    // ilgili kullanıcının userId bilgisi alındı.
    const [telefonNo, setTelefonNo] = useState("");
    const [konu, setKonu] = useState("");
    const [mesaj, setMesaj] = useState("");
    const { userId,token } = useAppContext();

    function handleTelefonNo(e){
        setTelefonNo(e.target.value);
    }

    function handleKonu(e){
        setKonu(e.target.value);
    }

    function handleMesaj(e){
        setMesaj(e.target.value);
    }

    const handleSubmit = () => {
        Swal.fire({
            title: "Teşekkürler!",
            text: "Geri bildiriminiz başarıyla alındı.",
            icon: "success",
            confirmButtonText: "Tamam",
          }).then((result) => {
            if (result.isConfirmed) {
                navigate("/");
            }
          });
      };

    const myFormSubmit = async (e)=>{
        e.preventDefault();
        const gonderilecekVeri = {
            subject: konu,
            context: mesaj,
            mobilephone: telefonNo
        }
        try{
            const response = await fetch('https://ai.kesifaraci.com/service/api/feedback', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify(gonderilecekVeri)
            });
            handleSubmit();
            
        }
        catch(error){
            Swal.fire({
                title: "Hata!",
                text: "Bir sorun oluştu, lütfen tekrar deneyin.",
                icon: "error",
                confirmButtonText: "Tamam",
              });
              
        }
        
    }

    function anaSayfayaDon(){
        navigate("/");  
    }

    return(
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="fixed inset-0 bg-black bg-opacity-50" onClick={anaSayfayaDon} />


            <div className="relative bg-white w-[90vw] max-w-4xl max-h-[90vh] overflow-y-auto rounded-lg p-6 z-10">
            <button
                    onClick={anaSayfayaDon}
                    className="absolute top-1 right-1 text-gray-500 hover:text-gray-700"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>

                <div className="text-center bg-[#3c4f58] text-white p-8 rounded-lg">
                    <h2 className="text-2xl font-semibold mb-4">{t('Geri Bildirim Formu')}</h2>
                    <form onSubmit={myFormSubmit}>
                        <div class="mb-6">
                            <label for="telefonNo" class="block mb-2 text-sm font-medium text-white dark:text-white text-left">{t('Telefon Numarası')}(İsteğe Bağlı)</label>
                            <input value={telefonNo} onChange={handleTelefonNo} type="text" id="telefonNo" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
                        </div>
                        <div class="mb-6">
                            <label for="konu" class="block mb-2 text-sm font-medium text-white dark:text-white text-left">{t('Konu')}</label>
                            <input value={konu} onChange={handleKonu} type="text" id="konu" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" required />
                        </div>
                        <div class="mb-6">  
                            <label for="mesaj" class="block mb-2 text-sm font-medium text-white dark:text-white text-left">{t('Mesaj')}</label>
                            <textarea value={mesaj} onChange={handleMesaj} id="mesaj" rows="4" class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" required></textarea>
                        </div>

                        <button type="submit" class="text-white bg-blue-700 hover:bg-blue-800 focus:outline-none  font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                        {t('Gönder')}
                            <svg class="rtl:rotate-180 w-3.5 h-3.5 ms-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9"/>
                            </svg>
                        </button>
                        
                    </form>


                </div>
            </div>
        </div>
        

        
    )
}

export default Feedback;